var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7949 15.0852C12.4518 15.0852 13.7949 13.7421 13.7949 12.0852C13.7949 10.4283 12.4518 9.0852 10.7949 9.0852C9.13807 9.0852 7.79492 10.4283 7.79492 12.0852C7.79492 13.7421 9.13807 15.0852 10.7949 15.0852Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79492 9.65027C1.79492 9.07592 1.79492 8.78874 1.86895 8.52427C1.93452 8.29 2.04229 8.06966 2.18695 7.87408C2.35026 7.65328 2.57694 7.47697 3.03031 7.12435L9.81262 1.84922C10.1639 1.57597 10.3396 1.43934 10.5336 1.38682C10.7047 1.34048 10.8851 1.34048 11.0563 1.38682C11.2502 1.43934 11.4259 1.57597 11.7772 1.84922L18.5595 7.12435C19.0129 7.47697 19.2396 7.65328 19.4029 7.87408C19.5476 8.06966 19.6553 8.29 19.7209 8.52427C19.7949 8.78874 19.7949 9.07592 19.7949 9.65027V16.8852C19.7949 18.0053 19.7949 18.5654 19.5769 18.9932C19.3852 19.3695 19.0792 19.6755 18.7029 19.8672C18.2751 20.0852 17.715 20.0852 16.5949 20.0852H4.99492C3.87482 20.0852 3.31476 20.0852 2.88694 19.8672C2.51062 19.6755 2.20466 19.3695 2.01291 18.9932C1.79492 18.5654 1.79492 18.0053 1.79492 16.8852V9.65027Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu_home.cce77a221bad92e9b484299c2517bbc7.svg";
export { ForwardRef as ReactComponent };